var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { injectable } from "inversify";
import { default as $ } from "cash-dom";
var AbstractComponent = /** @class */ (function () {
    function AbstractComponent(i18n, template) {
        this.i18n = i18n;
        this.template = template;
    }
    /*
     * COMPONENT INTERFACE
     */
    AbstractComponent.prototype.init = function () {
        var _this = this;
        //Create ui
        var html = this.template(this.getTemplateArguments());
        this.el = $(html);
        //Translate ui
        this.el.find('[translate]').each(function (index, ele) {
            var message = $(ele).text().trim();
            $(ele).text(_this.i18n.__(message));
        });
        //Attach to DOM
        $('body').append(this.el);
        //Bindings
        this.bind();
    };
    AbstractComponent.prototype.destroy = function () {
        this.el.remove();
    };
    AbstractComponent = __decorate([
        injectable(),
        __metadata("design:paramtypes", [Object, Function])
    ], AbstractComponent);
    return AbstractComponent;
}());
export { AbstractComponent };
